<!-- <div appClickOutside [excludeClasses]="['create-case-btn']" (clickOutside)="closePopup()" -->
  <div
  class="create-new-case-popup" [ngClass]="{'create-new-case-popup__sidebar': sidebar, 'create-new-case-popup__sidebar__expanded' : sidebar && sidebarExpanded}">
  <div class="create-new-case-popup-content">
    <form [formGroup]="form">
      <div class="popup-header">
        <div class="header-title">
          <div class="header-hash">#</div>
          <div>{{ 'title.dashboard.create_case_popup' | translate }}</div>
        </div>
        <i (click)="closePopup()" class="bi bi-x-lg close-button"></i>
      </div>
      <div class="popup-form-content">
        <input id="serialNumber" formControlName="serialNumber" placeholder="{{ 'placeholders.enter_serial_number' | translate }}" type="text" class="w-100" (ngModelChange)="searchForSerialNumbers($event)"/>
        <div class="serial-list-container">
            @for (item of serialObjectsList; track item) {
            <div class="serial-row">
              <div class="title">
                <div>{{ item.serialNumber }}</div>
                <div class="sub-title">{{ 'case.fields.customerContactName.label' | translate }}: <span class="value">{{ item.customerContactName ? item.customerContactName : '/' }}</span></div>
                <div class="sub-title">{{ 'case.fields.productComponentVarient.label' | translate }}: <span class="value">{{ item.productComponentVarient ? item.productComponentVarient : '/' }}</span></div>
              </div>
              <button class="create-btn" (click)="navigateTo('case-form-by-serial', item)">{{ 'buttons.select' | translate }}</button>
            </div>
          }
        </div>
        @if(!serialObjectsList.length && serialSearchTried) {
          <div class="create-popup-no-data">{{ 'label.no_results' | translate }}</div>
        }
        <div class="divider">
          <span>{{ 'label.or' | translate }}</span>
        </div>
        <button class="btn create-case-manually-button w-100" (click)="navigateTo('case-form')" >{{ 'buttons.continue_manually' | translate }}</button>
      </div>
    </form>
  </div>
</div>
